import { 
    GET_SYSTEM_ADMIN_CLIENTS_SUCCESS,
    GET_SYSTEM_ADMIN_HR_CLAIMS_LIST_SUCCESS,
    GET_SYSTEM_ADMIN_USERS_SUCCESS,
    GET_SYSTEM_ADMIN_USER_DETAIL_SUCCESS,
    GET_SYSTEM_ADMIN_EXCLUDED_CLINICS_SUCCESS,
    SUBMIT_SYSTEM_ADMIN_DELETE_EXCLUDED_CLINIC_SUCCESS,
    GET_SYSTEM_ADMIN_COMPANIES_SUCCESS
} from '../actions';

const initialState = {
    clients: [],
    users: [],
    accounts: [],
    hrclaims: [],
    userDetail: null,
    excludedClinics: [],
    companies:[]
};

export default function(state = initialState, action) {
    switch(action.type) {
        case GET_SYSTEM_ADMIN_COMPANIES_SUCCESS:
            return Object.assign({}, state, {companies: action.payload.data.clients});
        case GET_SYSTEM_ADMIN_CLIENTS_SUCCESS:
            return Object.assign({}, state, {clients: action.payload.data.clients});
        case GET_SYSTEM_ADMIN_HR_CLAIMS_LIST_SUCCESS:
            return Object.assign({}, state, {hrclaims: action.payload.data.hrclaims});
        case GET_SYSTEM_ADMIN_USERS_SUCCESS:
            return Object.assign({}, state, { users: action.payload.data.users });
        case GET_SYSTEM_ADMIN_USER_DETAIL_SUCCESS:
            return Object.assign({}, state, { userDetail: action.payload.data.user });
        case GET_SYSTEM_ADMIN_EXCLUDED_CLINICS_SUCCESS:
            return Object.assign({}, state, {excludedClinics: action.payload.data.excludedClinics});
        case SUBMIT_SYSTEM_ADMIN_DELETE_EXCLUDED_CLINIC_SUCCESS:
            return Object.assign({}, state, {excludedClinics: state.excludedClinics.filter(excludedClinic => excludedClinic._id !== action.id)});
        default:
            return state;
    }
}